import { InjectionToken } from "@angular/core";
import { ElementRef, Renderer2 } from "@angular/core";
import { SelectItem } from "primeng/api";
export const APP_CONFIG = new InjectionToken<Object>('APP CONFIG FILE');
export class appConfig {
    private static _appConfigService;

    public static get appConfigService() {
        return this._appConfigService;
    }
    public static set appConfigService(value) {
        this._appConfigService = value;
    }

    public static updateConstant(configData) {
        Constants.BASE_API_URL = configData?.baseApiUrl;
        Constants.GATEWAY_BASE_API_URL = configData?.gatewayBaseApiUrl;
        Constants.ADMIN_BASE_API_URL = configData?.adminBaseApiUrl;
        Constants.APP_BASE_API_URL = configData?.appBaseApiUrl;
        Constants.INACTIVITY_TIMEOUT_IN_MINS = configData?.inactivityTimeoutInMins;
        Constants.ADMIN_BASE_API_URL = configData?.adminBaseApiUrl;
        Constants.REPORT_BASE_API_URL = configData?.reportBaseApiUrl;
        Constants.PDF_BASE_API_URL = configData?.pdfBaseApiUrl;
        Constants.KSA_APP_BASE_API_URL = configData?.ksaSapApiBaseApiUrl;
        Constants.deploymentWindowCheckTimeInSeconds = configData?.deploymentWindowCheckTimeInSeconds || 10000;
        Constants.switchCountryURI = configData?.switchCountryUri;
        Constants.postLogoutRedirectURI = configData?.extPostLogoutRedirectUri;
    }
}

export class Constants {
    public static deploymentWindowCheckTimeInSeconds = 10000;
    public static BASE_API_URL = '';
    public static GATEWAY_BASE_API_URL = '';
    public static INACTIVITY_TIMEOUT_IN_MINS = 10;
    public static readonly LOCALE = 'en-IN';
    public static readonly AUTO_LOGOUT_URL =
        'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=' + window.location.origin;
    public static ADMIN_BASE_API_URL = '';
    public static APP_BASE_API_URL = '';
    public static REPORT_BASE_API_URL = '';
    public static PDF_BASE_API_URL = '';
    public static KSA_APP_BASE_API_URL = '';
    public static switchCountryURI = '';
    public static postLogoutRedirectURI = '';
    public static readonly FILE_SUCCESS_MSG = 'File uploaded successfully';
    public static readonly FILES_SUCCESS_MSG = 'Files uploaded successfully';
    public static readonly FILE_DUPLICATE_MSG = 'Duplicate file(s) are not allowed.';
    public static readonly FILEDUPLICATEMSG_PL = 'Duplicate file name found. Please upload files with unique names.';
    public static readonly FILE_EXCEPTION_MSG = 'Exception';
    public static readonly FILE_NORECORD_MSG = 'No records';
    public static readonly FILE_FORMAT_ISSUE = "Please upload the correct format.";
    public static readonly NETWORK_ERROR = "Please check the network connection.";
    public static readonly FILE_READ_ISSUE = "Issue in reading the file. Please try again.";
    public static readonly FILE_NAME_SPECIAL_CHARACTERS_ISSUE = "Please upload the correct format, as the file name contains special characters.";
    public static readonly FILE_TECHNICAL_ISSUE = "Technical Issue in uploading file. Please try again.";
    public static readonly dataStatusError1 = "Buyer VAT ID does not match with onboarded NIP";
    public static readonly dataStatusError2 = "Data is not in expected format, It may be due to the new line characters in a cell or tab";
    public static readonly dataStatusError3 = "Seller VAT ID does not match with onboarded NIP";
    public static readonly dataStatusError4 = "Buyer/Seller VAT ID does not match with onboarded NIP";
    public static readonly dataStatusError5 = "Error in ITT connectivity";
    public static readonly dataStatusError6 = "Process failed. Please try after some time. Unable to reach ITT system.";
    public static readonly dataStatusError7 = "Process failed. Credentials not found.";
    public static readonly dataStatusError8 = "Process failed. Please try after some time";
    public static readonly dataStatusError9 = "Process failed. Response not received from DMS.";
    public static readonly dataStatusError10 = "Invalid VAT ID";
    public static readonly invoiceManagement = "Invoice Management";
    public static readonly outwardInvoices = "Outward Invoices";
    public static readonly receipts = "RECEIPT";
    public static readonly consol = "CONSOL";
    public static readonly DATAIMPORT = "DATAIMPORT";
    public static readonly dashboard = "Dashboard";
    public static readonly printPdf = "Print PDF";
    public static readonly report = "Report";
    public static readonly report_XLSX = "Report (.xlsx)";
    public static readonly report_CSV = "Report (.csv)";
    public static readonly xml = "XML";
    public static readonly xml_json = "XML_JSON";
    public static readonly tableData = "Table Data";
    public static readonly legalFormat = "Legal Format";
    public static readonly generated = "Generated";
    public static readonly GENERATED = "GENERATED";
    public static readonly inProgress = "INPROGRESS";
    public static readonly INProgress = "IN-PROGRESS";
    public static readonly failed = "FAILED";
    public static readonly submitted = "Submitted";
    public static readonly dataReceivedDate = "DataReceivedDate";
    public static readonly documentDate = "DocumentDate";
    public static readonly ksefDate = "KSeFDate";
    public static readonly all = "ALL";
    public static readonly new = "NEW";
    public static readonly update = "UPDATE";
    public static readonly delete = "DELETE";
    public static readonly processedEY = "Processed_EY";
    public static readonly processedMoF = "Processed_MoF";
    public static readonly processedKSeF = "Processed_KSeF";
    public static readonly errorMoF = "Error_MoF";
    public static readonly errorKSeF = "Error_KSeF";
    public static readonly inprogressMof = "Inprogress_Mof";
    public static readonly inprogressKSeF = "Inprogress_KSeF";
    public static readonly processedSDI = "Processed_SDI";
    public static readonly errorSDI = "Error_SDI";
    public static readonly inprogressSDI = "Inprogress_SDI";
    public static readonly errorEY = "Error_EY";
    public static readonly errorGTES = "Error_GTES";
    public static readonly processedGTES = "Processed_GTES";
    public static readonly VALID_MAPPING_MSG = "Please select a valid Mapping."
    public static readonly FILE_COUNT_MSG = "Please select upto 10 files."
    public static readonly FILE_COUNT_MSG_I18N_KEY = "FILECOUNTISSUE_V2"
    public static readonly POWER_BI_REPORTS_ENDPOINT = "/getBIReportAccess";
    public static readonly FILE_NAME_SIZE_ISSUE = "FileName contains more than 100 characters, Please rename the file and reupload.";
    public static readonly pdf = "PDF";
    public static readonly pdf_english = "English PDF";
    public static readonly pdf_english_outward = "OUTWARD_ENGLISH_PDF";
    public static readonly pdf_english_inward = "INWARD_ENGLISH_PDF";
    public static readonly OUT_SDI = "OUT_SDI";
    public static readonly OUT_RESP_SDI = "OUT_RESP_SDI";
    public static readonly IN_SDI = "IN_SDI";
    public static readonly fetchMsg = 'FETCH_MSG'
    public static readonly FETCHDATA = "FETCHDATA";
    public static readonly INWARD = "INWARD";
    public static readonly Inward_Invoices = "Inward Invoices";
    public static readonly PDF_Reportcode = "RPT005";
    public static readonly PDF_Reportcode_English = "RPT032";
    public static readonly XML_Reportcode = "RPT006";
    public static readonly ATTACHMENT_Reportcode = "RPT007";
    public static readonly INWARD_REPORT_Reportcode = "RPT004";
    public static readonly INWARD_REPORT_CSV_Reportcode = "RPT025";
    public static readonly REPORT_CATEGORY_CODE = 'ACTN000024';
    public static readonly REPORT_SELF_USERLIST_CODE = 'ACTN000025';
    public static readonly REPORT_USERLIST_CODE = 'ACTN000026';
    public static readonly REPORT_SCREEN_CODE = 'SCREEN0006';
    public static readonly INWARD_TABLE_DATA_Reportcode = 'RPT009';
    public static readonly Custom_PDF = 'RPT028';
    public static readonly Custom_XML = 'RPT029';
    public static readonly Custom_Text = 'RPT030';
    public static readonly INWARD_RPT_LEGAL_CODE = 'RPT034';
    public static readonly GTES_SUMMARY_XML_Reportcode = 'RPT035';
    public static readonly RPTCODE_PASS_XML = 'RPT036';
    public static readonly RPTCODE_PASS_RPT = 'RPT037';
    public static readonly RPTCODE_PASS_TBL = 'RPT038';
    public static readonly RPTCODE_AGG_XML = 'RPT039';
    public static readonly RPTCODE_AGG_RPT = 'RPT040';
    public static readonly RPTCODE_AGG_TBL = 'RPT041';
    public static readonly RPTCODE_TXN_RPT = 'RPT042';
    public static readonly RPTCODE_TXN_TBL = 'RPT043';

    public static readonly MANUAL_TAB = "ACTN000021";
    public static readonly AUTOMATIC_TAB = "ACTN000022";
    public static readonly INVOICE_TAB = "ACTN000023";

    public static readonly ROLE_RECEIVED = "roleReceived";

    public static readonly countryEndpoints = {
        'RO': 'getRoE-invoiceDashboardData',
        'FR': 'getFRE-invoiceDashboardData',
        'PL': 'getPLE-invoiceDashboardData',
        'IT': 'getITE-invoiceDashboardData',
        'MY': 'getMYE-invoiceDashboardData'
    };
    public static readonly CURRENCY_OPTIONS: { name: string; value: string }[] = Array.from(new Set(
        'AED,AFN,ALL,AMD,ANG,AOA,ARS,AUD,AWG,AZN,BAM,BBD,BDT,BGN,BHD,BIF,BMD,BND,BOB,BOV,BRL,BSD,BTN,BWP,BYN,BZD,CAD,CDF,CHE,CHF,CHW,CLF,CLP,CNH,CNY,COP,COU,CRC,CUP,CVE,CZK,DJF,DKK,DOP,DZD,EGP,ERN,ETB,EUR,FJD,FKP,GBP,GEL,GHS,GIP,GMD,GNF,GTQ,GYD,HKD,HNL,HTG,HUF,IDR,ILS,INR,IQD,IRR,ISK,JMD,JOD,JPY,KES,KGS,KHR,KMF,KPW,KRW,KWD,KYD,KZT,LAK,LBP,LKR,LRD,LSL,LYD,MAD,MDL,MGA,MKD,MMK,MNT,MOP,MRU,MUR,MVR,MWK,MXN,MXV,MYR,MZN,NAD,NGN,NIO,NOK,NPR,NZD,OMR,PAB,PEN,PGK,PHP,PKR,PLN,PYG,QAR,RON,RSD,RUB,RWF,SAR,SBD,SCR,SDG,SEK,SGD,SHP,SLE,SOS,SRD,SSP,STN,SVC,SYP,SZL,THB,TJS,TMT,TND,TOP,TRY,TTD,TWD,TZS,UAH,UGX,USD,USN,UYI,UYU,UYW,UZS,VED,VES,VND,VUV,WST,XAF,XAG,XAU,XBA,XBB,XBC,XBD,XCD,XDR,XOF,XPD,XPF,XPT,XSU,XTS,XUA,XXX,YER,ZAR,ZMW,ZWG'.split(',')
    )).sort().map(c => ({ name: c, value: c }));
    public static readonly invoiceTypeList_MY_Translation = [
        { name: 'MYinvoice', code: '01' },
        { name: 'MYcreditNote', code: '02' },
        { name: 'MYdebitNote', code: '03' },
        { name: 'MYrefundNote', code: '04' },
        { name: 'MYselfBilledInvoice', code: '11' },
        { name: 'MYselfBilledCreditNote', code: '12' },
        { name: 'MYselfBilledDebitNote', code: '13' },
        { name: 'MYselfBilledRefundNote', code: '14' }
    ];

    public static readonly startWith_between = 'startswith_between';
    public static readonly equalsTo_between = 'equalsto_between';
    public static readonly notEqualsTo_between = 'notequalsto_between';
    public static readonly selectedMatchMode = 'startswith_between';
    public static readonly columnDateFilterMatchModeOptions: SelectItem[] = [
        { label: 'Start With', value: this.startWith_between },
        { label: 'Equals', value: this.equalsTo_between },
        { label: 'Not Equals', value: this.notEqualsTo_between }
    ];

    public static readonly countryPermList: { ctyCode: string; isPerm: string; }[] = [
        { ctyCode: 'PL', isPerm: "Y" },
        { ctyCode: 'RO', isPerm: "Y" },
        { ctyCode: 'IT', isPerm: "Y" },
        { ctyCode: 'FR', isPerm: "Y" },
        { ctyCode: 'JP', isPerm: "N" },
        { ctyCode: 'AU', isPerm: "N" },
        { ctyCode: 'KSA', isPerm: "N" },
        { ctyCode: 'IN', isPerm: "N" },
        { ctyCode: 'MY', isPerm: "Y" }
    ];
    public static readonly MSAL_DEFAULT_SCOPE = ['openid', 'profile', 'email', 'User.Read', 'User.ReadBasic.All'];
    public static readonly MSAL_SILENT_SCOPE = ['openid', 'profile', 'offline_access'];
    public onEnterKey(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            const yourDropdown = document.activeElement as HTMLElement;;
            if (yourDropdown) {
                yourDropdown.click();
                event.preventDefault();
            }
        }
    }
}

export class utility {
    setFilterIconAttributes(renderer: Renderer2, elementRef: ElementRef): void {
        const filtericonElements = elementRef.nativeElement.querySelectorAll('.pi.pi-filter-icon.pi-filter');
        filtericonElements.forEach(iconElement => {
            renderer.setProperty(iconElement, 'role', 'img');
            renderer.setAttribute(iconElement, 'aria-label', 'Filter');
        });
    }

    setPaginatorAttributes(renderer: Renderer2, elementRef: ElementRef) {
        const firstPageIcon = elementRef.nativeElement.querySelector('button.p-paginator-first.p-paginator-element.p-link');
        const prevPageIcon = elementRef.nativeElement.querySelector('button.p-paginator-prev.p-paginator-element.p-link');
        const nextPageIcon = elementRef.nativeElement.querySelector('button.p-paginator-next.p-paginator-element.p-link');
        const lastPageIcon = elementRef.nativeElement.querySelector('button.p-paginator-last.p-paginator-element.p-link');
        if (firstPageIcon) { renderer.setAttribute(firstPageIcon, 'aria-label', 'First Page'); }
        if (prevPageIcon) { renderer.setAttribute(prevPageIcon, 'aria-label', 'Previous Page'); }
        if (nextPageIcon) { renderer.setAttribute(nextPageIcon, 'aria-label', 'Next Page'); }
        if (lastPageIcon) { renderer.setAttribute(lastPageIcon, 'aria-label', 'Last Page'); }
    }
}
